// extracted by mini-css-extract-plugin
export var heading = "LanguageMenu-module--heading--b0c23";
export var languageList = "LanguageMenu-module--languageList--0d67f";
export var languageMenu = "LanguageMenu-module--languageMenu--2bdb3";